import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { cn } from "@/shared/lib/utils";
import styles from "./Brand.module.scss";
const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);
export const Brand = ({ size = "md", name = "Виртуоз", className, ...rest }) => {
    return (_jsxs("div", { className: cn(styles.brand, className), ...rest, children: [_jsx("span", { className: cn(styles.mark, styles[`mark${cap(size)}`]), "aria-hidden": "true", children: _jsx("img", { src: "/logo.jpg", alt: "", className: styles.markImg }) }), name !== null && _jsx("span", { className: styles.name, children: name })] }));
};
